<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container" v-if="p_pagina === 'R'">
            <router-link to="/referencia">Referencias</router-link>
            &rsaquo; Referencia {{ datoReferencia.idReferencia }}
          </div>
          <div class="breadcrumb-container" v-if="p_pagina === 'A'">
            <router-link to="/atencion">Atenciones</router-link>
            &rsaquo;
            <router-link
              :to="{
                name: 'AtencionForm',
                state: { idAtencion: p_idAtencion }
              }"
            >
              Atención {{ p_numeroAtencion }}
            </router-link>
            &rsaquo;
            <router-link
              :to="{
                name: 'Atencion_Referencia',
                state: {
                        idAtencion:     p_idAtencion,
                        estadoAtencion: p_estadoAtencion,
                        numero:         p_numeroAtencion,
                           }
              }"
            >
              Referencias - Derivaciones
            </router-link>
			
            &rsaquo; {{ p_idReferencia }}
          </div>
        </div>
        <div class="col-1 text-end">
          <button class="btn-help" type="button" @click="showModalHelp = true" title="Abrir ayuda">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <hr />

    <!-- Información principal -->
    <form>
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body form-card">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-3">
                  <label class="form-label">ID de Referencia</label>
                </div>
                <div class="col-9">
                  <span class="form-control-plaintext">{{ datoReferencia.idReferencia }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <label class="form-label">Nombre del Paciente</label>
                </div>
                <div class="col-9">
                  <span class="form-control-plaintext">{{ datoReferencia.pacienteNombre }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <label class="form-label">Motivo de Referencia</label>
                </div>
                <div class="col-9">
                  <span class="form-control-plaintext">{{ datoReferencia.motivoRefNombre }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bloque colapsable -->
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body form-card">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <b>Más información</b>
              <button class="btn btn-link p-0 text-decoration-none" @click.prevent="mostrarBloque = !mostrarBloque">
                <span class="material-symbols-outlined align-middle">
                  {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
                </span>
                {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más información' }}
              </button>
            </div>
            <div v-if="mostrarBloque">
              <div class="mb-3" v-for="campo in camposDetalle" :key="campo.key">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label">{{ campo.label }}</label>
                  </div>
                  <div class="col-9">
                    <span class="form-control-plaintext" style="text-transform: uppercase">
                      {{ datoReferencia[campo.key] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Tabs -->
    <div class="tab-bar mt-3">
      <button
        class="tablink"
        :class="{ 'active-tab': showTable === 'referenciaDet' }"
        @click="showTable = 'referenciaDet'"
      >
        <span class="material-symbols-outlined">diagnosis</span>
        Diagnósticos
      </button>
    </div>

    <!-- Contenido dinámico -->
    <div v-if="showTable === 'referenciaDet'">
      <ReferenciaDet
        :p_idAtencion="p_idAtencion"
        :p_numeroAtencion="p_numeroAtencion"
        :p_idReferencia="datoReferencia.idReferencia"
        :p_estadoAtencion="p_estadoAtencion"
      />
    </div>

    <!-- Formulario 053 -->
    <div class="mb-3 mt-3">
      <div class="row justify-content-center">
        <div class="col-md-4 text-center">
          <Modal v-model:modelValue="showModalDocumento" title="Formulario 053 - Referencia-Derivación">
            <DocVerFirmarGuardar :idReporte="7" :idDocumento="datoReferencia.idReferencia" />
          </Modal>
          <button
            type="button"
            class="btn btn-light"
            @click="showModalDocumento = true"
            title="Formulario 053 - Referencia-Derivación"
          >
            <span class="material-symbols-outlined" style="font-size: 32px; color: green; cursor: pointer;">
              quick_reference_all
            </span>
            Formulario 053 - Referencia-Derivación
          </button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DocVerFirmarGuardar from '../utils/DocVerFirmarGuardar.vue'
import ReferenciaDet from '../forms/ReferenciaDet.vue'
import dateFormat from '@/modules/dateFormat.js'
import api from '@/services/api'
import swal from 'sweetalert'

export default {
  components: { Layout, Footer, ReferenciaDet, DocVerFirmarGuardar },

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_numeroAtencion: { type: String, required: true },
    p_idReferencia:   { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_pagina:         { type: String, required: true },
  },

  data() {
    return {
      datoReferencia:    {},
      btnEditar:         false,
      mostrarBloque:     false,
      showTable:         'referenciaDet',
      showModalHelp:     false,
      showModalDocumento: false,

      camposDetalle: [
        { key: 'empresaOrigen',  label: 'Empresa de Origen' },
        { key: 'empresaDestino', label: 'Empresa de Destino' },
        { key: 'medicoNombre',   label: 'Nombre del Médico' },
        { key: 'fechaReg',       label: 'Fecha de Registro' },
        { key: 'fechaRef',       label: 'Fecha de Referencia' },
        { key: 'hora',           label: 'Hora' },
        { key: 'tipo',           label: 'Tipo' },
        { key: 'motivo',         label: 'Motivo' },
        { key: 'resumen',        label: 'Resumen' },
        { key: 'hallazgos',      label: 'Hallazgos' },
        { key: 'tratamiento',    label: 'Tratamiento' },
        { key: 'justificada',    label: 'Justificación' },
      ],
    }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.getData()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    getData() {
      api.get('/vwreferencias/' + this.p_idReferencia)
        .then(response => { this.datoReferencia = response.data })
        .catch(error => { console.error('Error al obtener datos de la referencia:', error) })
    },

    async guardarReferencia() {
      try {
        await api.post('/referencias', this.datoReferencia)
        swal('Correcto!', 'Referencia creada exitosamente!', 'success')
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },
  },
}
</script>

<style scoped>
/* Botón de ayuda */
.btn-help {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #0d6efd;
}
.btn-help .material-symbols-outlined {
  font-size: 32px;
  transition: color 0.2s;
}
.btn-help:hover .material-symbols-outlined {
  color: #0a58ca;
}

/* Tab bar */
.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}
.tablink:hover {
  background: #e9ecef;
  color: #343a40;
}
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}

.modal-body label {
  font-weight: bold;
}
</style>